import { shadowGridProfile } from '../themeProfiles/shadowGrid';

// Shadow Grid Theme - legacy field style (neon blue accents)
export const shadowGridTheme = {
  name: 'shadowGrid',
  colors: {
    primary: '#00d4ff',
    primaryDark: '#00e0ff',
    secondary: '#8bb8d8',
    background: '#020503',
    backgroundSecondary: 'rgba(0, 0, 0, 0.45)',
    surface: 'rgba(5, 6, 8, 0.78)',
    surfaceHover: 'rgba(8, 8, 10, 0.85)',
    text: '#ffffff',
    textSecondary: '#e0e0e0',
    textMuted: '#b0b0b0',
    textDisabled: '#666666',
    border: 'rgba(0, 255, 170, 0.35)',
    borderLight: 'rgba(0, 255, 170, 0.2)',
    borderMuted: 'rgba(0, 255, 170, 0.12)',
    error: '#ff4444',
    success: '#4caf50',
    warning: '#ffaa00',
  },
  fonts: {
    body: "'Courier New', monospace",
    heading: "'Rajdhani', sans-serif",
  },
  gradients: {
    background: 'linear-gradient(135deg, #0a0f0a 0%, #1a2a1a 50%, #0a1a0a 100%)',
    surface: 'linear-gradient(135deg, rgba(0, 212, 255, 0.08) 0%, transparent 50%)',
    primary: 'linear-gradient(135deg, #00d4ff, #00a4ff)',
    glow: 'radial-gradient(circle at 20% 50%, rgba(0, 212, 255, 0.1) 0%, transparent 50%)',
  },
  shadows: {
    primary: '0 0 20px rgba(0, 212, 255, 0.5)',
    card: '0 5px 20px rgba(0, 212, 255, 0.3)',
    button: '0 0 18px rgba(0, 212, 255, 0.45)',
  },
  animatedBackground: {
    gridColor: 'rgba(0, 212, 255, 0.1)',
    circleColor: '#00d4ff',
    scanlineColor: '#00d4ff',
  },
  styles: {
    cardBorderRadius: '15px',
    cardBackdrop: 'blur(10px)',
    buttonBorderRadius: '8px',
    headerBackground: 'rgba(5, 6, 8, 0.85)',
    headerBorder: 'rgba(0, 255, 170, 0.25)',
  },
  profile: shadowGridProfile,
};
